<template>
  <div>
    <v-card-text>
      <v-row>
        <v-col cols="6" lg="6" md="12" sm="12" xl="12">
          <v-text-field
              dense
              outlined
              label="Search"
              v-model="searchTerm"
          >
          </v-text-field>
        </v-col>
        <v-col cols="6" lg="6" md="12" sm="12" xl="12">
          <v-switch
              class="mt-0"
              v-model="brandComponentIsAllParameters"
              label="all available parameters"
              color="secondary"
              @change="onChangeBrandComponentIsAllParameters($event)"
          >
          </v-switch>
        </v-col>
      </v-row>
      <v-data-table
          :headers="columns"
          :items="getBrandComponentSpec"
          item-key="id"
          class="elevation-1"
          :search="searchTerm"
          dense
          multi-sort
          :sort-by="['section', 'parameter_name']"
          fixed-header
          :height="$vuetify.breakpoint.height - 290"
          :options="{
              page: 0,
              itemsPerPage: -1,
              sortBy: ['section', 'parameter_name'],
              mustSort: true
            }"
          hide-default-footer
      >
        <template v-slot:item.value="props">
               <span v-if="props.item.parameter_type === 'list'">
                    <v-combobox
                        class="mt-3 mb-n3"
                        v-model="props.item.display_value"
                        :items="props.item.choice_list"
                        dense
                        outlined
                        label="choice"
                    ></v-combobox>
               </span>
          <span v-else-if="props.item.parameter_type === 'float'" class="parameter-edit">
                  <v-text-field
                      class="mt-3 mb-n3"
                      v-model="props.item.float_value"
                      label="edit"
                      dense
                      outlined
                  ></v-text-field>
              </span>
          <span v-else class="parameter-edit">
                  <v-text-field
                      class="mt-3 mb-n3"
                      v-model="props.item.value"
                      label="edit"
                      dense
                      outlined
                      clearable
                  ></v-text-field>
              </span>
        </template>

      </v-data-table>
    </v-card-text>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from "vuex";
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: 'getFieldBrandComponentSpec',
  mutationType: 'updateFieldBrandComponentSpec',
});

export default {
  name: 'BrandComponentSpec',
  props: ['brandComponentId', 'brandComponentCategory'],
  components: {},
  computed: {
    ...mapGetters(['getBrandComponentSpec']),
    ...mapFields(['brandComponentSpec', 'brandComponentIsAllParameters'])
  },
  methods: {
    ...mapActions(['fetchBrandComponentSpec', 'fetchBrandComponentCategorySpec']),
    ...mapMutations(['updateBrandComponentIsAllParameters']),
    onChangeBrandComponentIsAllParameters(value) {
      this.updateBrandComponentIsAllParameters(value)
      this.fetchBrandComponentSpec(this.brandComponentId)
      this.fetchBrandComponentCategorySpec(this.brandComponentCategory)
    },
  },
  async mounted() {
    await this.fetchBrandComponentSpec(this.brandComponentId);
    await this.fetchBrandComponentCategorySpec(this.subcategory__category)
  },
  data() {
    return {
      dialog: false,
      searchTerm: null,
      columns: [
        {
          text: 'Section',
          value: 'section',
        },
        {
          text: 'Parameter name',
          value: 'parameter_name',
        },
        {
          text: 'Value',
          value: 'value',
        },
        {
          text: 'Unit',
          value: 'unit',
        },
      ],
    }
  },
};
</script>

<style scoped lang="scss">
</style>